<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'over'">
        <mat-toolbar color="white">
            <mat-toolbar-row class="desktop">
                <img src="assets/images/generico/logo.png" class="logo_nav_bar">
                <span style="cursor: pointer;" (click)="getForm('0','', true)" class="titulo_nav_bar">Formularios</span>
                <span class="spacer"></span>
                <div class="circulo online " style="margin-right: 5px"></div>
                <div><span style="font-size: 15px">Online</span></div>
                <div class="circulo offline" style="margin-left: 15px; margin-right: 5px"></div>
                <div><span style="font-size: 15px; margin-right: 5px">Presencial</span></div>
                <button mat-icon-button arial-label="Cerrar menu" (click)="drawer.toggle()">
                    <mat-icon class="icon">clear</mat-icon>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row class="mobile">
                <img src="assets/images/generico/logo.png" class="logo_nav_bar">
                <span style="cursor: pointer;" (click)="getForm('0','', true)" class="titulo_nav_bar">Formularios</span>
                <span class="spacer"></span>
                <button mat-icon-button arial-label="Cerrar menu" (click)="drawer.toggle()">
                    <!-- style="right:" -->
                    <mat-icon class="icon">clear</mat-icon>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row class="mobile">
                <div class="circulo online " style="margin-right: 5px"></div>
                <div><span style="font-size: 15px">Online</span></div>
                <span class="spacer"></span>
                <div class="circulo offline" style="margin-left: 15px; margin-right: 5px"></div>
                <div><span style="font-size: 15px; margin-right: 5px">Presencial</span></div>
            </mat-toolbar-row>
        </mat-toolbar>
        <mat-nav-list style="padding-top:0px !important">


            <mat-accordion>
                <div *ngFor=" let materia of materias; let i = index ">
                    <mat-expansion-panel [expanded]="materia.num == expandedItem" *ngIf="materia.active">

                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon [svgIcon]="materia.icon" class="iconCustom"></mat-icon><strong>
                                    {{materia.name}}</strong>
                            </mat-panel-title>

                        </mat-expansion-panel-header>
                        <div *ngFor=" let form of materia.forms; let ii = index">
                            <!-- {{form.name}} -->
                            <a *ngIf="form.active" mat-list-item (click)="getForm(form.num,  form.name, form.online); ">
                                <div class="cuadrado online">{{form.num}}</div>
                                <h5 style="width: 95%">{{form.name }}</h5>
                            </a>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>

            <!-- <mat-accordion *ngIf="forms.length > 0">
                <mat-expansion-panel
                    *ngIf="forms['1.1'].active != 'false' ||forms['1.3'].active != 'false' || forms['1.5'].active != 'false' || forms['1.7'].active != 'false' || forms['1.9'].active != 'false'"
                    [expanded]="uno == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="obramenor" class="iconCustom"></mat-icon><strong> Permisos de obra
                                menor</strong>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <a *ngIf="forms['1.1'].active != 'false' " mat-list-item
                        (click)="getForm('1.1',  forms['1.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">1.1</div>
                        <h5 style="width: 95%">{{forms['1.1'].name }}</h5>
                    </a>
                    <a *ngIf="forms['1.3'].active != 'false'" mat-list-item
                        (click)="getForm('1.3',  forms['1.3'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">1.3</div>
                        <h5 style="width: 95%">{{forms['1.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['1.5'].active != 'false'" mat-list-item
                        (click)="getForm('1.5', forms['1.5'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">1.5</div>
                        <h5 style="width: 95%">{{forms['1.5'].name}}</h5>
                    </a>
                    <a *ngIf="forms['1.7'].active != 'false'" mat-list-item
                        (click)="getForm('1.7',  forms['1.7'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">1.7</div>
                        <h5 style="width: 95%">{{forms['1.7'].name}}</h5>
                    </a>
                    <a *ngIf="forms['1.9'].active != 'false'" mat-list-item
                        (click)="getForm('1.9', forms['1.9'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">1.9</div>
                        <h5 style="width: 95%">{{forms['1.9'].name}}</h5>
                    </a>
                </mat-expansion-panel>


                <mat-expansion-panel
                    *ngIf="forms['2.1'].active != 'false' ||forms['2.3'].active != 'false' || forms['2.5'].active != 'false' || forms['2.7'].active != 'false' ||
                    forms['2-1.1'].active != 'false' ||forms['2-1.2'].active != 'false' || forms['2-1.3'].active != 'false' || forms['2-1.4'].active != 'false' ||
                    forms['2-3.1'].active != 'false' ||forms['2-3.2'].active != 'false' || forms['2-3.3'].active != 'false' || forms['2-3.4'].active != 'false' || forms['2-3.5'].active != 'false' ||
                    forms['2-5.1'].active != 'false' ||forms['2-5.2'].active != 'false' || forms['2-5.3'].active != 'false' || forms['2-5.4'].active != 'false' || forms['2-5.5'].active != 'false' ||
                    forms['2-7.1'].active != 'false' ||forms['2-7.2'].active != 'false' || forms['2-7.3'].active != 'false' || forms['2-7.4'].active != 'false' || forms['2-7.5'].active != 'false' 
                    "
                    [expanded]="dos == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="edificacion" class="iconCustom"></mat-icon><strong> Permisos de
                                edificación</strong>
                        </mat-panel-title>
                    </mat-expansion-panel-header>


                    <a *ngIf="forms['2.1'].active != 'false'" mat-list-item
                        (click)="getForm('2.1', forms['2.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2.1</div>
                        <h5 style="width: 95%">{{forms['2.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2.3'].active != 'false'" mat-list-item
                        (click)="getForm('2.3', forms['2.3'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2.3</div>
                        <h5 style="width: 95%">{{forms['2.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2.5'].active != 'false'" mat-list-item
                        (click)="getForm('2.5', forms['2.5'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2.5</div>
                        <h5 style="width: 95%">{{forms['2.5'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2.7'].active != 'false'" mat-list-item
                        (click)="getForm('2.7',  forms['2.7'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2.7</div>
                        <h5 style="width: 95%">{{forms['2.7'].name}}</h5>
                    </a>





                    <a *ngIf="forms['2-1.1'].active != 'false'" mat-list-item
                        (click)="getForm('2-1.1', forms['2-1.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-1.1</div>
                        <h5 style="width: 95%">{{forms['2-1.1'].name}}</h5>
                    </a>

                    <a *ngIf="forms['2-1.2'].active != 'false'" mat-list-item
                        (click)="getForm('2-1.2', forms['2-1.2'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-1.2</div>
                        <h5 style="width: 95%">{{forms['2-1.2'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-1.3'].active != 'false'" mat-list-item
                        (click)="getForm('2-1.3', forms['2-1.3'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2-1.3</div>
                        <h5 style="width: 95%">{{forms['2-1.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-1.4'].active != 'false'" mat-list-item
                        (click)="getForm('2-1.4',  forms['2-1.4'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-1.4</div>
                        <h5 style="width: 95%">{{forms['2-1.4'].name}}</h5>
                    </a>



                    <a *ngIf="forms['2-3.1'].active != 'false'" mat-list-item
                        (click)="getForm('2-3.1', forms['2-3.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-3.1</div>
                        <h5 style="width: 95%">{{forms['2-3.1'].name}}</h5>
                    </a>

                    <a *ngIf="forms['2-3.2'].active != 'false'" mat-list-item
                        (click)="getForm('2-3.2', forms['2-3.2'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-3.2</div>
                        <h5 style="width: 95%">{{forms['2-3.2'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-3.3'].active != 'false'" mat-list-item
                        (click)="getForm('2-3.3', forms['2-3.3'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2-3.3</div>
                        <h5 style="width: 95%">{{forms['2-3.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-3.4'].active != 'false'" mat-list-item
                        (click)="getForm('2-3.4',  forms['2-3.4'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-3.4</div>
                        <h5 style="width: 95%">{{forms['2-3.4'].name}}</h5>
                    </a>


                    <a *ngIf="forms['2-3.5'].active != 'false'" mat-list-item
                        (click)="getForm('2-3.5', forms['2-3.5'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-3.5</div>
                        <h5 style="width: 95%">{{forms['2-3.5'].name}}</h5>
                    </a>

                    <a *ngIf="forms['2-5.1'].active != 'false'" mat-list-item
                        (click)="getForm('2-5.1', forms['2-5.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-5.1</div>
                        <h5 style="width: 95%">{{forms['2-5.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-5.2'].active != 'false'" mat-list-item
                        (click)="getForm('2-5.2', forms['2-5.2'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2-5.2</div>
                        <h5 style="width: 95%">{{forms['2-5.2'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-5.3'].active != 'false'" mat-list-item
                        (click)="getForm('2-5.3',  forms['2-5.3'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-5.3</div>
                        <h5 style="width: 95%">{{forms['2-5.3'].name}}</h5>
                    </a>

                    <a *ngIf="forms['2-5.4'].active != 'false'" mat-list-item
                        (click)="getForm('2-5.4', forms['2-5.4'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-5.4</div>
                        <h5 style="width: 95%">{{forms['2-5.4'].name}}</h5>
                    </a>

                    <a *ngIf="forms['2-5.5'].active != 'false'" mat-list-item
                        (click)="getForm('2-5.5', forms['2-5.5'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-5.5</div>
                        <h5 style="width: 95%">{{forms['2-5.5'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-7.1'].active != 'false'" mat-list-item
                        (click)="getForm('2-7.1', forms['2-7.1'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2-7.1</div>
                        <h5 style="width: 95%">{{forms['2-7.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-7.2'].active != 'false'" mat-list-item
                        (click)="getForm('2-7.2',  forms['2-7.2'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-7.2</div>
                        <h5 style="width: 95%">{{forms['2-7.2'].name}}</h5>
                    </a> 


                    <a *ngIf="forms['2-7.3'].active != 'false'" mat-list-item
                        (click)="getForm('2-7.3', forms['2-7.3'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-7.3</div>
                        <h5 style="width: 95%">{{forms['2-7.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-7.4'].active != 'false'" mat-list-item
                        (click)="getForm('2-7.4', forms['2-7.4'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">2-7.4</div>
                        <h5 style="width: 95%">{{forms['2-7.4'].name}}</h5>
                    </a>
                    <a *ngIf="forms['2-7.5'].active != 'false'" mat-list-item
                        (click)="getForm('2-7.5',  forms['2-7.5'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">2-7.5</div>
                        <h5 style="width: 95%">{{forms['2-7.5'].name}}</h5>
                    </a>


                </mat-expansion-panel>
                <mat-expansion-panel
                    *ngIf="forms['3.1'].active != 'false' || forms['3.3'].active != 'false' || forms['3.6'].active != 'false' || forms['3.8'].active != 'false' || forms['3.10'].active != 'false' "
                    [expanded]="tres == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="subdivision" class="iconCustom"></mat-icon><strong> Subdivisión y
                                urbanización</strong>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <a *ngIf="forms['3.1'].active != 'false'" mat-list-item
                        (click)="getForm('3.1', forms['3.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">3.1</div>
                        <h5 style="width: 95%">{{forms['3.1'].name}} </h5>
                    </a>
                    <a *ngIf="forms['3.3'].active != 'false'" mat-list-item
                        (click)="getForm('3.3', forms['3.3'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">3.3</div>
                        <h5 style="width: 95%">{{forms['3.3'].name}} </h5>
                    </a>
                    <a *ngIf="forms['3.6'].active != 'false'" mat-list-item
                        (click)="getForm('3.6', forms['3.6'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">3.6</div>
                        <h5 style="width: 95%">{{forms['3.6'].name}}</h5>
                    </a>
                    <a *ngIf="forms['3.8'].active != 'false'" mat-list-item
                        (click)="getForm('3.8', forms['3.8'].name.toUpperCase() ,true); ">
                        <div class="cuadrado online">3.8</div>
                        <h5 style="width: 95%">{{forms['3.8'].name}}</h5>
                    </a>
                    <a *ngIf="forms['3.10'].active != 'false'" mat-list-item
                        (click)="getForm('3.10', forms['3.10'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">3.10</div>
                        <h5 style="width: 95%">{{forms['3.10'].name}}</h5>
                    </a>
                </mat-expansion-panel>
                <mat-expansion-panel
                    *ngIf="forms['4.3'].active != 'false' ||forms['4.5'].active != 'false' || forms['4.7'].active != 'false' "
                    [expanded]="cuatro == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="division" class="iconCustom"></mat-icon><strong> División del
                                suelo</strong>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <a *ngIf="forms['4.1'].active != 'false'" mat-list-item
                        (click)="getForm('4.1', forms['4.1'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">4.1</div>
                        <h5 style="width: 95%">{{forms['4.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['4.3'].active != 'false'" mat-list-item
                        (click)="getForm('4.3', forms['4.3'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">4.3</div>
                        <h5 style="width: 95%">{{forms['4.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['4.5'].active != 'false'" mat-list-item
                        (click)="getForm('4.5',  forms['4.5'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">4.5</div>
                        <h5 style="width: 95%">{{forms['4.5'].name}}</h5>
                    </a>
                </mat-expansion-panel>

                <mat-expansion-panel *ngIf="forms['5.6'].active != 'false' ||forms['5.8'].active != 'false' "
                    [expanded]="cinco == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="copropiedad" class="iconCustom"></mat-icon> <strong> Copropiedad y/o
                                Obras Preliminares</strong>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <a *ngIf="forms['5.6'].active != 'false'" mat-list-item
                        (click)="getForm('5.6',  forms['5.6'].name.toUpperCase(), true); ">
                        <div class="cuadrado online">5.6</div>
                        <h5 style="width: 95%">{{forms['5.6'].name}}</h5>
                    </a>
                    <a *ngIf="forms['5.8'].active != 'false'" mat-list-item
                        (click)="getForm('5.8', forms['5.8'].name.toUpperCase(),true); ">
                        <div class="cuadrado online">5.8</div>
                        <h5 style="width: 95%">{{forms['5.8'].name}}</h5>
                    </a>
                </mat-expansion-panel>


                <mat-expansion-panel
                    *ngIf="forms['8.1'].active != 'false' || forms['8.3'].active != 'false' || forms['8.5'].active != 'false' || forms['8.7'].active != 'false' || forms['8.9'].active != 'false' || forms['8.10'].active != 'false' ||forms['8.11'].active != 'false' || forms['8.13'].active != 'false' "
                    [expanded]="ocho == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="catastrofes" class="iconCustom"></mat-icon><strong> Para construcciones
                                en zonas afectadas por catastrofes</strong>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <a *ngIf="forms['8.1'].active != 'false' " mat-list-item
                        (click)="getForm('8.1', forms['8.1'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.1</div>
                        <h5 style="width: 95%">{{forms['8.1'].name}} </h5>
                    </a>
                    <a *ngIf="forms['8.3'].active != 'false' " mat-list-item
                        (click)="getForm('8.3',  forms['8.3'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.3</div>
                        <h5 style="width: 95%">{{forms['8.3'].name}}</h5>
                    </a>
                    <a *ngIf="forms['8.5'].active != 'false' " mat-list-item
                        (click)="getForm('8.5',  forms['8.5'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.5</div>
                        <h5 style="width: 95%">{{forms['8.5'].name}}</h5>
                    </a>
                    <a *ngIf="forms['8.7'].active != 'false' " mat-list-item
                        (click)="getForm('8.7',  forms['8.7'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.7</div>
                        <h5 style="width: 95%">{{forms['8.7'].name}}</h5>
                    </a>
                    <a *ngIf="forms['8.9'].active != 'false' " mat-list-item
                        (click)="getForm('8.9',  forms['8.9'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.9</div>
                        <h5 style="width: 95%">{{forms['8.9'].name}}</h5>
                    </a>
                    <a *ngIf="forms['8.10'].active != 'false' " mat-list-item
                        (click)="getForm('8.10',  forms['8.10'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.10</div>
                        <h5 style="width: 95%">{{forms['8.10'].name}}</h5>
                    </a>
                    <a *ngIf="forms['8.11'].active != 'false' " mat-list-item
                        (click)="getForm('8.11',  forms['8.11'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.11</div>
                        <h5 style="width: 95%">{{forms['8.11'].name}} </h5>
                    </a>
                    <a *ngIf="forms['8.13'].active != 'false' " mat-list-item
                        (click)="getForm('8.13', forms['8.13'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">8.13</div>
                        <h5 style="width: 95%">{{forms['8.13'].name}}</h5>
                    </a>
                </mat-expansion-panel>

                <mat-expansion-panel *ngIf="forms['11.1'].active != 'false' || forms['11.3'].active != 'false' "
                    [expanded]="once == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="antenas" class="iconCustom"></mat-icon><strong> Para permisos de
                                instalación de torres soportes de antenas</strong>
                        </mat-panel-title>
                    </mat-expansion-panel-header>


                    <a *ngIf="forms['11.1'].active != 'false' " mat-list-item
                        (click)="getForm('11.1',  forms['11.1'].name.toUpperCase(), 'true');  ">
                        <div class="cuadrado online">11.1</div>
                        <h5 style="width: 95%">{{forms['11.1'].name}}</h5><b style="width: 5%">11.1</b>
                    </a>
                    <a *ngIf="forms['11.3'].active != 'false' " mat-list-item
                        (click)="getForm('11.3',  forms['11.3'].name.toUpperCase(), 'true');  ">
                        <div class="cuadrado online">11.3</div>
                        <h5 style="width: 95%">{{forms['11.3'].name}}</h5><b style="width: 5%">11.3</b>
                    </a>
                </mat-expansion-panel>

                <mat-expansion-panel
                    *ngIf="forms['12.1'].active != 'false' || forms['12.4'].active != 'false' || forms['12.6'].active != 'false' || forms['12.8'].active != 'false' "
                    [expanded]="doce == 'true'">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="regularizacion" class="iconCustom"></mat-icon><strong> Regularización ley
                                N 20.898</strong>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <a *ngIf="forms['12.1'].active != 'false' " mat-list-item
                        (click)="getForm('12.1',  forms['12.1'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">12.1</div>
                        <h5 style="width: 95%">{{forms['12.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['12.4'].active != 'false' " mat-list-item
                        (click)="getForm('12.4', forms['12.4'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">12.4</div>
                        <h5 style="width: 95%">{{forms['12.4'].name}}</h5>
                    </a>
                    <a *ngIf="forms['12.6'].active != 'false' " mat-list-item
                        (click)="getForm('12.6', forms['12.6'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">12.6</div>
                        <h5 style="width: 95%">{{forms['12.6'].name}}</h5>
                    </a>
                    <a *ngIf="forms['12.8'].active != 'false' " mat-list-item
                        (click)="getForm('12.8', forms['12.8'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">12.8</div>
                        <h5 style="width: 95%">{{forms['12.8'].name}}</h5>
                    </a>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="trece == 'true'"
                    *ngIf="forms['13.1'].active != 'false' || forms['13.3'].active != 'false' ">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon svgIcon="institucion" class="iconCustom"></mat-icon><strong> Regularización ley
                                20.301 y 21.052</strong>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <a *ngIf="forms['13.1'].active != 'false' " mat-list-item
                        (click)="getForm('13.1', forms['13.1'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">13.1</div>
                        <h5 style="width: 95%">{{forms['13.1'].name}}</h5>
                    </a>
                    <a *ngIf="forms['13.3'].active != 'false' " mat-list-item
                        (click)="getForm('13.3', forms['13.3'].name.toUpperCase(), 'true'); ">
                        <div class="cuadrado online">13.3</div>
                        <h5 style="width: 95%">{{forms['13.3'].name}}</h5>
                    </a>
                </mat-expansion-panel>

            </mat-accordion> -->
        </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content>
        <mat-toolbar class="icon_muni_1">
            <mat-toolbar-row>
                <span><img src="assets/images/generico/logo.png" style="width: 30px; height: 30px;"> </span>
                <span class="col-md-4">Expedientes - Municipalidad
                    de {{ nombreMuni }}</span>
                <div align="center" class="col-md-4">
                </div>
            </mat-toolbar-row>
            <mat-toolbar-row>

                <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>

                <span class="spacer"></span>

                <div class="col-sm-4 align-right" align="right">

                    <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                        arial-label="Información del perfil">
                        <mat-icon *ngIf="nombreMuni=='Lo Barnechea'" class="icon">person</mat-icon>
                        <mat-icon *ngIf="nombreMuni!='Lo Barnechea'" class="icon"
                            [matBadge]="contador_definitivo == 0 ? '' : contador_definitivo" matBadgeColor="warn">person
                        </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">

                        <!-- <button mat-menu-item (click)="getForm('0','', true)">
                            <mat-icon class="iconcolor">work</mat-icon>
                            <span>Inicio</span>
                        </button> -->
                        <button *ngIf="nombreMuni != 'Lo Barnechea'" mat-menu-item (click)="getSolicitudes();">
                            <mat-icon class="iconcolor">feedback</mat-icon>
                            <span>Mis Solicitudes</span>
                        </button>

                        <button *ngIf="false" mat-menu-item (click)="verBorradores()">
                            <mat-icon class="iconcolor">history</mat-icon>
                            <span>Mis Borradores</span>
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <mat-icon class="iconcolor">exit_to_app</mat-icon>
                            <span>Cerrar sesión</span>
                        </button>
                    </mat-menu>
                    <button mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio" (click)="back()">
                        <mat-icon class="icon">home</mat-icon>
                    </button>
                </div>

            </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="icon_muni_2 responsive_elemento" color="white">


            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <span><img src="assets/images/generico/logo.png" style="height: 50px;"> </span>
            <span class="col-md-4 ">Expedientes - Municipalidad
                de {{ nombreMuni }}</span>
            <div align="center" class="col-md-4">
            </div>
            <div class="col-md-4" align="right">

                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                    arial-label="Información del perfil">
                    <mat-icon *ngIf="nombreMuni=='Lo Barnechea'" class="icon">person</mat-icon>
                    <mat-icon *ngIf="nombreMuni!='Lo Barnechea'" class="icon"
                        [matBadge]="contador_definitivo == 0 ? '' : contador_definitivo" matBadgeColor="warn">person
                    </mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                    <!-- <button mat-menu-item (click)="getForm('0','', true)">
                        <mat-icon class="iconcolor">work</mat-icon>
                        <span>Inicio</span>
                    </button> -->
                    <button *ngIf="nombreMuni != 'Lo Barnechea'" mat-menu-item (click)="getSolicitudes();">
                        <mat-icon class="iconcolor">feedback</mat-icon>
                        <span>Mis Solicitudes</span>
                    </button>

                    <button *ngIf="false" mat-menu-item (click)="verBorradores()">
                        <mat-icon class="iconcolor">history</mat-icon>
                        <span>Mis Borradores</span>
                    </button>
                    <button mat-menu-item (click)="logout()">
                        <mat-icon class="iconcolor">exit_to_app</mat-icon>
                        <span>Cerrar sesión</span>
                    </button>
                </mat-menu>
                <button mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio" (click)="back()">
                    <mat-icon class="icon">home</mat-icon>
                </button>
            </div>

        </mat-toolbar>

        <section class="fondo">
            <div class="container">
                <div class="board">

                    <msw-navbar *ngIf="form | async as p" [form]="p.form" [title]="p.title"></msw-navbar>
                    <page-instructions></page-instructions>

                </div>
            </div>
        </section>
    </mat-sidenav-content>
    <!-- <mat-sidenav-content>
        <mat-toolbar class="icon_muni" color="white">
            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <span><img src="assets/images/generico/logo.png" style="width: auto; height: 50px;"> Expedientes - Municipalidad
                de {{ nombreMuni }}</span>
            <div align="center" class="col-md-4">
            </div>
            <div class="col-md-4" align="right">
    
                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Mi Perfil"
                    arial-label="Información del perfil">
                    <mat-icon class="icon" [matBadge]="contador_definitivo == 0 ? '' : contador_definitivo"
                        matBadgeColor="warn">person</mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                    <button *ngIf="false" mat-menu-item (click)="getForm('0','', true)">
                        <mat-icon class="iconcolor">work</mat-icon>
                        <span>Inicio</span>
                    </button>
                    <button *ngIf="false" mat-menu-item (click)="getSolicitudes();">
                        <mat-icon class="iconcolor">feedback</mat-icon>
                        <span>Mis Solicitudes</span>
                    </button>
    
                    <button *ngIf="false" mat-menu-item (click)="verBorradores()">
                        <mat-icon class="iconcolor">history</mat-icon>
                        <span>Mis Borradores</span>
                    </button>
                    <button mat-menu-item (click)="logout()">
                        <mat-icon class="iconcolor">exit_to_app</mat-icon>
                        <span>Cerrar sesión</span>
                    </button>
                </mat-menu>
                <button mat-icon-button matTooltip="Servicios" arial-label="Volver al inicio" (click)="back()">
                    <mat-icon class="icon">home</mat-icon>
                </button>
            </div>
        </mat-toolbar>
    
        <section class="fondo">
            <div class="container">
                <div class="board">
    
                    <msw-navbar *ngIf="form | async as p" [form]="p.form" [title]="p.title"></msw-navbar>
                    <page-instructions></page-instructions>
    
                </div>
            </div>
        </section>
    </mat-sidenav-content> -->
</mat-sidenav-container>
<section>
    <div class="ftr">
        <p class="ftr-txt">
            {{footer}}
            <br>
            <a [href]="webUrl" target="_blank"> {{web}}</a>
        </p>
    </div>
</section>



<ng-template #mailSave>
    <h2 mat-dialog-title>Su correo no está en nuestros registros</h2>
    <mat-dialog-content>
        <p>Su registro no cuenta con correo asociado. Por favor, ingrese su dirección de email para poder continuar</p>
        <form [formGroup]="mail">
            <mat-form-field class="input-form">
                <input matInput placeholder="Correo" type="email" name="correo" formControlName="email"
                    onpaste="return false;" onCopy="return false" onCut="return false" />
                <mat-error *ngIf="mail.controls.email.errors?.required">Email requerido
                </mat-error>
                <mat-error *ngIf="mail.controls.email.errors?.pattern">Formato incorrecto. Ej: correo@servidor.dominio.
                </mat-error>
                <mat-error *ngIf="mail.controls.email.errors?.maxlength">Excede el máximo de caracteres (50).
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" id="ingreso_mail" [disabled]="mail.status == 'INVALID'"
            (click)="submitMail()">Aceptar </button>
    </mat-dialog-actions>
</ng-template>